export const DEFAULT_TEST_ID = 'GLOBAL_TEST_ID' as const;
